import React , { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Avatar from "react-avatar";
import { getCategoryList } from "../redux/actions/CategoryActions";
import { GetProfileAction } from "../redux/actions/UserActions";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {APP_PROJECT_BASE_URL} from "../config/config";
import LogoUplatz from "../uplatz-eLearning-logo.png";
import { getAuth ,truncateText} from "../utils/Helper";
import { Logout } from "../utils/Logout";

interface ContentItem {
  id: number;
  category_id: number;
  slug: string;
  title: string;
}

interface Category {
  id: number;
  name: string;
  content: ContentItem[];
}
type UserData = {
  cart_count: number;
  data : {}
  // add more fields if needed
};

const Header: React.FC = () => {

  const dispatch = useDispatch<any>();
  const [categoryList, setCategoryList] = useState('');
  const [headerCategory, setHeaderCategory] = useState('');
  const [moreCategory, setMoreCategory] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState('');
  const [userData, setUserData] = useState<UserData | null>(null);
  const auth = getAuth();
  const categories = useSelector((state: any) => state.category.category_data || []);
  const {data ,status , loading, error} = useSelector((state: any) => state.getProfileState || []);
  const { status_add } = useSelector((state: any) => state.cartAddState || {});
  const { status_delete} = useSelector((state: any) => state.cartDeleteState || []);
  

  //const data: any = [];

  useEffect(() => {
    if (categories?.data) {
      const filtered = categories?.header_category?.filter((cat: any) => cat.is_header_menu == 1);
      console.log("filtered : ",filtered)

      const unfiltered = categories.data.filter((cat: any) => cat.is_header_menu == 0);
      console.log("unfiltered list: ", unfiltered);

      // Add "More..." item
      const moreItem = {
        id: -1,
        slug: 'more',
        parent_id: null,
        icon: '➕',
        name: 'More..',
        is_header_menu: 1
      };
      const updatedList :any  = [...filtered, moreItem];

      console.log("updated list: ", updatedList);
      setHeaderCategory(updatedList);
      
      setCategoryList(updatedList);
      setMoreCategory(unfiltered);
    }
  }, [dispatch,categories]);

  useEffect(() => {
    console.log("auth : ",auth);
    if(auth){
      dispatch(GetProfileAction({}))
    }
    dispatch(getCategoryList())
  }, []);

  useEffect(() => {
    if(auth){
      dispatch(GetProfileAction({}))
    }    
    //dispatch(GetProfileAction({}))
  }, [status_add,status_delete]);

     //{console.log(categories)}

  const navigate = useNavigate();
  const location = useLocation();

  const handleExploreClick = (e: React.MouseEvent) => {
    e.preventDefault();

    if (location.pathname !== "/") {
      // Navigate to home with a state telling it to scroll after mount
      navigate("/", { state: { scrollTo: "categories-list" } });

      setTimeout(() => {
        const section = document.getElementById("categories-list");
        section?.scrollIntoView({ behavior: "smooth" });
      }, 500); // delay 1 second
    } else {
      const section = document.getElementById("categories-list");
      section?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleLogout = () => {
    console.log("Trigger Logout ..... 2")
    Logout(navigate);
  };

  useEffect(() => {
    if (data) {
      setUserData(data)
      console.log("data : ",data)
    }
  }, [data]);


  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light shadow-sm">
      <div className="container">
        <Link className="navbar-brand fw-bold" to={"/"}>
          <img src={LogoUplatz}  alt="logo" style={{width:'110px'}} />
        </Link>
        {/* <a className="navbar-brand fw-bold" href="/"> */}
        {/* </a> */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mainNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
       
        <div className="collapse navbar-collapse " id="mainNav">
          <ul className="navbar-nav ms-auto d-flex flex-row align-items-center" style={{ fontSize: "16px",fontWeight:'400' }}>

            <Link to="#" className="nav-link d-flex align-items-center"
              onClick={handleExploreClick} >
              Categories
            </Link>
            {Array.isArray(headerCategory) &&
              headerCategory.map((cat: any) => (
                <li
                  className={`nav-item ${cat?.content?.length > 0 || cat.slug === 'more' ? "dropdown" : ""}`}
                  key={cat?.id}
                >
                  {cat.slug === 'more' ? (
                    <>
                      <a
                        className="nav-link d-flex align-items-center"
                        href="#"
                        id="moreDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        {cat.name}
                      </a>
                      <ul className="dropdown-menu custom-dropdown-scroll" aria-labelledby={`dropdown-${cat?.id}`}>
                        {Array.isArray(moreCategory) && moreCategory?.map((more: any, index1: number) => (
                          <Fragment key={more.id}>
                            <li>
                              <Link className="dropdown-item" to={`/${more?.slug}`}>
                                {more?.name }
                                
                              </Link>
                            </li>
                            {index1 < moreCategory?.length - 1 && <li><hr className="dropdown-divider" /></li>}
                          </Fragment>
                        ))}
                      </ul>
                    </>
                  ) : cat?.content?.length > 0 ? (
                    <>
                      <Link className="nav-link" to={`/${cat?.slug}`}>
                        {cat.name}
                      </Link>
                    </>
                  ) : (
                    <Link className="nav-link" to={`/${cat?.slug}`}>
                      {cat.name}
                    </Link>
                  )}
                </li>
              ))}

              { !auth && (
                  <Link to="/login" className="nav-link d-flex align-items-center">
                    <i className="bi bi-box-arrow-in-right me-2"></i> Login
                  </Link>
              )}
          </ul>

              { auth && (
                <div className="d-flex align-items-center">
                  <div className="cart-icon">
                    <Link className="text-decoration-none text-dark" to={"/cart"}>
                        <i className="bi bi-cart3 fs-5"></i>
                        {Number(userData?.cart_count) > 0 && (
                          <span className="cart-count">{userData?.cart_count}</span>
                        )}
                    </Link>
                  </div>

                  <div className="dropdown">
                    <a href="#" className="d-flex align-items-center text-decoration-none dropdown-toggle" id="dropdownUser" data-bs-toggle="dropdown" aria-expanded="false">
                      {/* <img src="https://randomuser.me/api/portraits/men/32.jpg" alt="profile" width="32" height="32" className="rounded-circle me-2" /> */}
                      <Avatar name={auth?.name} size="32" round={true} color="#3568B2" fgColor="#fff" className="rounded-circle me-2" />
                      <span className="d-none d-sm-inline">{truncateText(auth?.name, 13)}</span>
                    </a>
                    <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownUser">
                      <li><Link className="dropdown-item" to={"/dashboard"}>Dashboard</Link></li>
                      <li><Link className="dropdown-item" to={"/settings"}>Settings</Link></li>
                      <hr className="dropdown-divider" />
                      <li>
                        <button className="dropdown-item" onClick={handleLogout}>Sign out</button>
                      </li>
                    </ul>
                  </div>
                  </div>
              )}

        </div>
      </div>
    </nav>
  );
};

export default Header;
